<template>
  <div>
    <table class="table is-fullwidth is-hoverable my-table" :class="{'has-add-button': editable}">
      <thead>
        <th class="num-cell" v-if="showLineNum">#</th>
        <th v-for="(c, i) in columns" :key="'t-h-'+i" :class="{'num-cell': c.type == 'number'}">
          {{ c.label }}
        </th>
        <th v-if="editable">Action</th>
      </thead>
      <tfoot v-if="showTotals">
        <th class="num-cell" v-if="showLineNum">Total</th>
        <th v-for="(c, i) in columns" :key="'t-h-'+i" :class="{'num-cell': c.type == 'number'}">
          <span v-if="c.type == 'number'">
            {{ c.formatter ? c.formatter(totals[i]) : totals[i] }}
          </span>
        </th>
        <th v-if="editable"></th>
      </tfoot>
      <tbody>
        <tr v-for="(r, i) in showingRows" :key="'t-r-' + i">
          <td class="num-cell" v-if="showLineNum">{{i+1}}</td>
          <td v-for="(c, j) in columns" :key="'t-r-'+i+'-'+j" :class="{'num-cell': c.type == 'number'}">
            <span v-if="c.formatter">{{ c.formatter(r[c.name]) }}</span>
            <span v-if="c.options">{{ getOptionText(r[c.name], c.options) }}</span>
            <span v-if="!c.formatter && !c.options">{{ r[c.name] }}</span>
          </td>
          <td v-if="editable">
            <a @click="openItemModal(i)">
              <span class="icon">
                <i class="fas fa-edit"></i>
              </span>
            </a>
            <a class="has-text-danger ml-3" @click="deleteItem(i)">
              <span class="icon">
                <i class="fas fa-trash"></i>
              </span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="button" @click="openItemModal(-1)">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Add</span>
    </button>
    <item-modal :items="rows" :itemSchema="columns" :item="itemModal.item" :opened="itemModal.opened" @closeItemModal="closeItemModal"></item-modal>
  </div>
</template>

<script>
import ItemModal from './ItemModal.vue'

export default {
  name: 'my-table',
  components: {
    ItemModal
  },
  props: ['itemSchema', 'items', 'editable', 'showLineNum', 'showTotals'],
  data () {
    return {
      rows: [],
      itemModal: {
        opened: false,
        item: null,
        index: -1,
      }
    }
  },
  computed: {
    columns () {
      return this.itemSchema.map(field => {
        if (typeof field === 'string') {
          return {
            name: field,
            label: field,
            type: 'string',
          }
        }
        var f = {...field}
        if (!f.type) {
          f.type = 'string'
        }
        if (!f.label) {
          f.label = f.name
        }
        if (f.options) {
          for (var i=0;i<f.options.length;i++) {
            var o = f.options[i]
            if (typeof o !== 'object') {
              f.options[i] = {
                text: o,
                value: o,
              }
            }
          }
        }
        return f
      })
    },
    showingRows () {
      return this.rows.slice()
    },
    totals () {
      var totals = []
      for (var i=0;i<this.columns.length;i++) {
        var c = this.columns[i]
        if (c.type === 'number') {
          var sum = 0
          for (var j=0;j<this.rows.length;j++) {
            sum += this.rows[j][c.name]
          }
          totals.push(sum)
        } else {
          totals.push('')
        }
      }
      return totals
    },
  },
  watch: {
    items: function (val) {
      if (!val) {
        this.rows = []
      } else {
        if (val.length != this.rows.length) {
          this.rows = val.slice()
        } else {
          for (var i = 0; i < val.length; i++) {
            if (!this.isRowSame(val[i], this.rows[i])) {
              this.rows = val.slice()
              break
            }
          }
        }
      }
    },
    rows: function (val) {
      this.$emit('itemsChanged', val.slice())
    },
  },
  methods: {
    isRowSame (r1, r2) {
      for (var c of this.columns) {
        if (r1[c.name] !== r2[c.name]) {
          return false
        }
      }
      return true
    },
    getOptionText (value, options) {
      for (var o of options) {
        if (o.value === value) {
          return o.text
        }
      }
      return value
    },
    openItemModal (index) {
      this.itemModal.index = index
      if (index >= 0) {
        this.itemModal.item = this.rows[index]
      } else {
        this.itemModal.item = null
      }
      this.itemModal.opened = true
    },
    closeItemModal (newItem) {
      if (newItem) {
        if (this.itemModal.index >= 0) {
          this.rows.splice(this.itemModal.index, 1, newItem)
        } else {
          this.rows.push(newItem)
        }
      }
      this.itemModal.opened = false
    },
    deleteItem (index) {
      var confirm = {
        title: 'Remove item',
        message: 'Are you sure to remove this item?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.deleteItemConfirmed,
          args: [index]
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    deleteItemConfirmed (index) {
      this.rows.splice(index, 1)
    },
  },
  mounted () {
    if (this.items) {
      this.rows = this.items.slice()
    }
  },
}
</script>

<style lang="scss" scoped>
.has-add-button {
  margin-bottom: 10px;
}

.num-cell {
  text-align: right !important;
}
</style>
